import { IntervalsTypeId as IntervalsTypeId$1, make as make$1, empty as empty$1, fromIterable as fromIterable$1, union as union$1, intersect as intersect$1, start as start$1, end as end$1, lessThan as lessThan$1, isNonEmpty as isNonEmpty$1, max as max$1 } from '../../internal/schedule/intervals.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const IntervalsTypeId = IntervalsTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * An `Intervals` represents a list of several `Interval`s.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Creates a new `Intervals` from a `List` of `Interval`s.
 *
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

/**
 * Constructs an empty list of `Interval`s.
 *
 * @since 2.0.0
 * @category constructors
 */
const empty = empty$1;

/**
 * Constructs `Intervals` from the specified `Iterable<Interval>`.
 *
 * @since 2.0.0
 * @category constructors
 */
const fromIterable = fromIterable$1;

/**
 * Computes the union of this `Intervals` and  that `Intervals`
 *
 * @since 2.0.0
 * @category utils
 */
const union = union$1;

/**
 * Produces the intersection of this `Intervals` and that `Intervals`.
 *
 * @since 2.0.0
 * @category utils
 */
const intersect = intersect$1;

/**
 * The start of the earliest interval in the specified `Intervals`.
 *
 * @since 2.0.0
 * @category getters
 */
const start = start$1;

/**
 * The end of the latest interval in the specified `Intervals`.
 *
 * @since 2.0.0
 * @category getters
 */
const end = end$1;

/**
 * Returns `true` if the start of this `Intervals` is before the start of that
 * `Intervals`, `false` otherwise.
 *
 * @since 2.0.0
 * @category ordering
 */
const lessThan = lessThan$1;

/**
 * Returns `true` if this `Intervals` is non-empty, `false` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const isNonEmpty = isNonEmpty$1;

/**
 * Returns the maximum of the two `Intervals` (i.e. which has the latest start).
 *
 * @since 2.0.0
 * @category ordering
 */
const max = max$1;

export { IntervalsTypeId, empty, end, fromIterable, intersect, isNonEmpty, lessThan, make, max, start, union };
